import Dashboard from "../../template/pages/Dashboard/Dashboard";
import tableBasic from "../../template/pages/Tables/tableBasic/tableBasic";
import Icons from "../../template/pages/UI/Icons/Icons";
import Badges from "../../template/pages/UI/Badges/Badges";
import Gallery from "../../template/pages/Extra/Gallery/Gallery";
import Calendar from "../../template/pages/Extra/Calendar/Calendar";
import Carousel from "../../template/pages/UI/Carousel/Carousel";
import Cards from "../../template/pages/UI/Cards/Cards";
import Notifications from "../../template/pages/UI/Notifications/Notifications";
import FormsElements from "../../template/pages/Forms/FormsElements/FormsElements";
import FormsValidation from "../../template/pages/Forms/FormsValidation/FormsValidation";
import Tooltips from "../../template/pages/UI/Tooltips/Tooltips";
import Pagination from "../../template/pages/UI/Pagination/Pagination";
import Progress from "../../template/pages/UI/Progress/Progress";
import SearchResult from "../../template/pages/Extra/SearchResult/SearchResult";
import Profile from "../../template/pages/User/Profile/Profile";
import Add from "../../template/pages/User/Add/Add";
import Edit from "../../template/pages/User/Edit/Edit";
import List from "../../template/pages/User/List/List";
import ProductManagement from "../../template/pages/E-commerce/ProductManagement/ProductManagement";
import ProductsGrid from "../../template/pages/E-commerce/ProductGrid/ProductsGrid";
import ProductDetail from "../../template/pages/E-commerce/ProductDetail/ProductDetail";
import Typography from "../../template/pages/Core/Typography/Typography";
import Colors from "../../template/pages/Core/Colors/Colors";
import Grid from "../../template/pages/Core/Grid/Grid";
import Google from "../../template/pages/Maps/Google/Google";
import Vector from "../../template/pages/Maps/Vector/Vector";
import TimeLine from "../../template/pages/Extra/TimeLine/TimeLine";
import Invoice from "../../template/pages/Extra/Invoice/Invoice";
import tableDynamic from "../../template/pages/Tables/tableDynamic/tableDynamic";
import Modal from "../../template/pages/UI/Modal/Modal";
import Navbar from "../../template/pages/UI/Navbar/Navbar";
import Tabs from "../../template/pages/UI/Tabs/Tabs";
import ChartsOverview from "../../template/pages/Charts/Overview/ChartsOverview";
import LineCharts from "../../template/pages/Charts/LineCharts/LineCharts";
import BarCharts from "../../template/pages/Charts/BarCharts/BarCharts";
import PieCharts from "../../template/pages/Charts/PieCharts/PieCharts";

const layoutRoutes = [
    {
        path: "dashboard",
        name: "Dashboard" ,
        component: Dashboard
    },
    //Tables
    {
        path: "tables/basic",
        name: "TablesBasic",
        component: tableBasic
    },
    {
        path: "tables/dynamic",
        name: "TablesDynamic",
        component: tableDynamic
    },
    //UI Elements
    {
        path: "ui/icons",
        name: "UiIcons",
        component: Icons
    },
    {
        path: "ui/badges",
        name: "UiBadges",
        component: Badges
    },
    {
        path: "ui/carousel",
        name: "UiCarousel",
        component: Carousel
    },
    {
        path: "ui/cards",
        name: "UiCards",
        component: Cards
    },
    {
        path: "ui/modal",
        name: "UiModal",
        component: Modal
    },
    {
        path: "ui/notifications",
        name: "UiNotifications",
        component: Notifications
    },
    {
        path: "ui/tooltips",
        name: "UiTooltips",
        component: Tooltips
    },
    {
        path: "ui/pagination",
        name: "UiPagination",
        component: Pagination
    },
    {
        path: "ui/progress",
        name: "UiProgress",
        component: Progress
    },
    {
        path: "ui/navbar",
        name: "UiNavbar",
        component: Navbar
    },
    {
        path: "ui/tabs",
        name: "UiTabs",
        component: Tabs
    },
    //Forms
    {
        path: "forms/elements",
        name: "FormsElements",
        component: FormsElements
    },
    {
        path: "forms/validation",
        name: "FormsValidation",
        component: FormsValidation
    },
    //Charts
    {
        path: "charts/overview",
        name: "ChartsOverview",
        component: ChartsOverview
    },
    {
        path: "charts/line-charts",
        name: "LineCharts",
        component: LineCharts
    },
    {
        path: "charts/bar-charts",
        name: "BarCharts",
        component: BarCharts
    },
    {
        path: "charts/pie-charts",
        name: "PieCharts",
        component: PieCharts
    },
    //Extra
    {
        path: "extra/timeLine",
        name: "ExtraTimeLine",
        component: TimeLine
    },
    {
        path: "extra/invoice",
        name: "Invoice",
        component: Invoice
    },
    {
        path: "extra/search-result",
        name: "ExtraSearchResult",
        component: SearchResult
    },
    {
        path: "extra/gallery",
        name: "ExtraGallery",
        component: Gallery
    },
    {
        path: "extra/calendar",
        name: "ExtraCalendar",
        component: Calendar
    },
    //Maps
    {
        path: "maps/google",
        name: "GoogleMaps",
        component: Google
    },
    {
        path: "maps/vector",
        name: "VectorMaps",
        component: Vector
    },
    //Core
    {
        path: "core/typography",
        name: "CoreTypography",
        component: Typography
    },
    {
        path: "core/colors",
        name: "CoreColors",
        component: Colors
    },
    {
        path: "core/grid",
        name: "CoreGrid",
        component: Grid
    },
    //E-commerce
    {
        path: "e-commerce/management",
        name: "ProductManagement",
        component: ProductManagement
    },
    {
        path: "e-commerce/grid",
        name: "ProductsGrid",
        component: ProductsGrid
    },
    {
        path: "e-commerce/detail",
        name: "ProductDetail",
        component: ProductDetail
    },
    //User
    {
        path: "user/profile",
        name: "UserProfile",
        component: Profile
    },
    {
        path: "user/add",
        name: "UserAdd",
        component: Add
    },
    {
        path: "user/edit",
        name: "UserEdit",
        component: Edit
    },
    {
        path: "user/list",
        name: "UserList",
        component: List
    }
]

export default layoutRoutes